var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationWarning = function SvgNotificationWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FF8A43",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M6.32 1.74.846 10.857a1.94 1.94 0 0 0-.01 1.939c.343.602.984.978 1.682.985h10.959a1.97 1.97 0 0 0 1.69-.985 1.93 1.93 0 0 0-.006-1.93L9.68 1.74A1.96 1.96 0 0 0 8 .797a1.96 1.96 0 0 0-1.677.94l-.002.003zM8 2.11c.217 0 .42.113.533.301l5.474 9.114a.635.635 0 0 1-.539.944H2.524a.62.62 0 0 1-.528-.317.64.64 0 0 1 .002-.636l5.47-9.106A.63.63 0 0 1 8 2.11"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M7.333 5.388v2.58c0 .362.299.655.667.655a.66.66 0 0 0 .667-.656V5.388A.66.66 0 0 0 8 4.732a.66.66 0 0 0-.667.656"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10.546,
    r: 1
  }))));
};
export default SvgNotificationWarning;